import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Zamów produkty drukowane',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Szczegóły produktu',
    [ProductOrderingSteps.ShippingInfo]: 'Informacje o wysyłce',
    payment: 'Płatność',
  },
  form: {
    title: 'Szczegóły zamówienia',
    polygraphy_product_id: {
      label: 'Produkt',
      placeholder: 'Wybierz produkt',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Ulotka - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Szablon #1 🆕',
            [FlyerTemplate.Two]: 'Szablon #2 🆕',
            [FlyerTemplate.Three]: 'Szablon #3',
            [FlyerTemplate.Four]: 'Szablon #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Naklejka - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Szablon #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Naklejka na drzwi - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Szablon #1 🆕',
            [DoorStickerTemplate.Two]: 'Szablon #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Ilość',
      placeholder: 'Podaj ilość',
    },
    service_level: {
      label: 'Poziom usługi',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Oszczędny',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standardowy',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Ekspresowy',
      },
    },
    shipping_company_name: {
      label: 'Firma',
      placeholder: 'Podaj nazwę firmy',
    },
    shipping_salutation: {
      label: 'Tytuł',
      options: {
        mr: 'Pan',
        mrs: 'Pani',
      },
    },
    shipping_first_name: {
      label: 'Imię',
      placeholder: 'Wprowadź imię',
    },
    shipping_last_name: {
      label: 'Nazwisko',
      placeholder: 'Wprowadź nazwisko',
    },
    shipping_country: {
      label: 'Kraj',
      placeholder: 'Wybierz kraj',
    },
    shipping_state: {
      label: 'Stan',
      placeholder: 'Wybierz stan',
    },
    shipping_city: {
      label: 'Miasto',
      placeholder: 'Wprowadź miasto',
    },
    shipping_address: {
      label: 'Adres',
      placeholder: 'Wprowadź adres',
    },
    shipping_zip_code: {
      label: 'Kod pocztowy',
      placeholder: 'Wprowadź kod pocztowy',
    },
    shipping_phone_number: {
      label: 'Numer telefonu',
      placeholder: 'Wprowadź numer telefonu',
    },
    create_invoice: {
      options: {
        true: 'Nalicz automatycznie – opłata pobierana natychmiast',
        false: 'Wyślij bezpłatnie – to prezent',
      },
    },
  },
  table: {
    title: 'Poprzednie zamówienia',
    fields: {
      product: 'Produkt',
      quantity: 'Ilość',
      status: 'Status',
      service_level: 'Poziom usługi',
      shipping: 'Wysyłka',
      tracking_url: 'URL śledzenia',
      created: 'Utworzono',
      updated: 'Ostatnia aktualizacja',
    },
  },
  labels: {
    shipping_company: 'Firma',
    shipping_salutation: 'Tytuł',
    shipping_first_name: 'Imię',
    shipping_last_name: 'Nazwisko',
    shipping_address: 'Adres',
    shipping_zip_code: 'Kod pocztowy',
    shipping_city: 'Miasto',
    shipping_phone_number: 'Numer telefonu',
    show_shipping_details: 'Szczegóły wysyłki',
    track_order: 'Śledź zamówienie',
    pending_from_provider: 'Oczekuje na dostawcę',
  },
  modals: {
    confirmation: {
      title: 'Potwierdź szczegóły zamówienia',
    },
    free_order_confirmation: {
      title: 'Czy na pewno chcesz wysłać {{product}} bezpłatnie?',
      description: 'Nie pobierasz dziś opłaty od klienta.\n Produkt zostanie wysłany bez płatności.',
      buttons: {
        confirm: 'Tak, wyślij bezpłatnie',
      },
    },
  },
  buttons: {
    back_to_templates: 'Powrót do szablonów',
    preview: 'Podgląd',
    next: 'Dalej',
    order: 'Utwórz zamówienie',
    confirm: 'Potwierdź',
  },
  feedback: {
    shop_url_used: 'Produkt zawiera URL sklepu online (<url>{{url}}</url>). Czy to celowe?',
    order_total_price: 'Łączna cena wybranych produktów: <strong>{{amount}} NET</strong>',
  },
  toasts: {
    failed_to_create_order: 'Nie udało się utworzyć zamówienia',
    order_got_created: 'Zamówienie zostało utworzone',
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
